import { IOrganizationDepartmentInput } from 'redux/reducers/organization-department';

import * as Yup from 'yup';

export const organizationDepartmentInitialValues: IOrganizationDepartmentInput = {
  name: '',
  // phone_no: '',
  email: '',
  status: true,
  code: '',
  organization_id: '',
  organization:""
};

export const OrganizationDepoartmentSchemaValidations = Yup.object().shape({
  name: Yup.string().min(2, 'Too Short!').max(100, 'Too Long!').required('Title is required'),
  // phone_no: Yup.number().required('Phone number is required'),
  organization_id: Yup.number().required('Organization is required'),
  // email: Yup.string().email('Invalid email').required('Email is required'),
  status: Yup.boolean().required('Required')
});
